import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PERMISSION_HO_TEAM_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-content-inbox-personal',
  templateUrl: './home-content-inbox-personal.component.html',
  styleUrls: ['./home-content-inbox-personal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentInboxPersonalComponent implements OnInit {
  @Input() handoversInboxPersonal: Handover[] | undefined;
  @Input() totalHandoversInboxPersonal: number | undefined;
  @Input() searchInboxPersonal: string | undefined;
  @Output() reloadPersonal = new EventEmitter<boolean>();
  @Output() eventShowInboxPersonal = new EventEmitter<boolean>();
  @Output() handoversInboxPersonalWithFilter = new EventEmitter<string>();

  canPermissionTeam = false;
  destinationLabel = 'De';
  textSearch = '';

  constructor(private userService: UserService) {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    this.canPermissionTeam = this.userService.hasPermission(
      PERMISSION_HO_TEAM_ID
    );
    this.textSearch = this.searchInboxPersonal ? this.searchInboxPersonal : '';
  }

  eventReload(reload: boolean) {
    this.reloadPersonal.emit(true);
  }
  showInboxTeam() {
    this.eventShowInboxPersonal.emit(false);
  }

  getHandoversHomeInboxPersonalWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversInboxPersonalWithFilter.emit(searchText);
  }
}
